<template>
    <div class="com-record-item dsp-flex" @click.passive="clickRecordItem">
        <div class="com-record-basic">
            <p class="com-record-name">{{recordData.name.slice(0, 10)}}</p>
            <p class="com-record-info">
                <span>{{recordData.sex}}</span><span>{{recordData.dateStr}}</span><!--<span>03:03</span>-->
            </p>
            <p class="com-record-sub">
                <span class="com-record-group">分组:{{recordData.group.slice(0, 10)}}</span>
                <span class="com-record-icon-span">
                    <i v-if="recordData.toBaike" class="iconfont icon-baike"></i>
                    <i v-if="recordData.pipan" class="iconfont icon-pipan"></i>
                    <i v-if="recordData.lunpan" class="iconfont icon-lunpan"></i>
                    <i v-if="recordData.hongbao" class="iconfont icon-hongbao"></i>
                    <i v-if="recordData.shengri" class="iconfont icon-shengri"></i>
                </span>
            </p>
        </div>
        <div class="com-record-detail">
            <div class="dsp-flex">
                <div class="com-record-word" v-for="(wordValue, index) in recordData.eightWordArr" v-bind:key="wordValue[0] + wordValue[1] + index">
                    <p v-bind:class="'wd-' + wordValue[0].propXingEn">{{wordValue[0].text}}</p>
                    <p v-bind:class="'wd-' + wordValue[1].propXingEn">{{wordValue[1].text}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 记录列表元素基类
 */
export default {
    name: 'RecordItem',
    props: {
        recordData: {
            type: Object,
            default() { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    methods: {
        clickRecordItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.recordData);
            }
        }
    }
}
</script>